import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as runReducer from "containers/Run/reducer";
import * as setupReducer from "containers/Setup/reducer";
import {
  getSortedScores,
  getCsv,
  getError,
  getIsDownloadLoading,
  handleUpload,
  handleFileChange,
  handleDownload
} from "containers/Deploy/reducer";

import { handleRestfulDeploy } from "containers/Deployments/reducer";

import ModelTileContainer from "containers/Tiles/ModelTile";

import MiniDeploy from "components/MiniDeploy/MiniDeploy";

class MiniDeployContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { id, model, modelId, handleUpload, handleDownload, handleRestfulDeploy, history } = this.props;

    return (
      <MiniDeploy
        {...this.props}
        handleRestfulDeploy={(id, modelName) => handleRestfulDeploy(id, modelName)}
        handleDownload={(scoreId, modelId, url) => handleDownload(id, scoreId, modelId, url)}
        handleComplete={(response) => handleUpload(id, modelId, response)}
        handleBack={() => history.push("/job/" + id)}
        modelTile={<ModelTileContainer model={model} id={id} isNoClick={true} />}
      />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  init: () => dispatch(init()),
  handleRestfulDeploy: (id, modelName) => dispatch(handleRestfulDeploy(id, modelName)),
  handleUpload: (id, modelId, response) => dispatch(handleUpload(id, modelId, response)),
  handleDownload: (id, scoreId, modelId, url) => dispatch(handleDownload(id, scoreId, modelId, url)),
  updateDeploy: () => dispatch(runReducer.toggleDeploy(ownProps.id)),

  handleFileChange: (file) => dispatch(handleFileChange(ownProps.id, ownProps.modelId, file))
});

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;
  const modelId = ownProps.modelId;

  return {
    id: id,
    isScoreUploading: runReducer.getIsScoreUploading(state, id),
    modelId: modelId,
    label: setupReducer.getLabel(state, id),
    model: runReducer.getTransformedModelById(state, id, modelId),
    scores: getSortedScores(state, id, modelId),
    csv: getCsv(state, id, modelId),
    isDownloadLoading: getIsDownloadLoading(state, id, modelId),
    error: getError(state, id, modelId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(MiniDeployContainer);
